import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

// Links that come from Contentful are data, not code: only web, mail and on-site links are
// rendered as links. Anything else (javascript:, data:, vbscript:...) is dropped.
export function safeHref(uri) {
  const value = String(uri ?? "").trim();
  if (/^(https?:\/\/|mailto:)/i.test(value)) return value;
  if (value.startsWith("/") && !value.startsWith("//")) return value;
  return null;
}

export const isExternalHref = (href) => /^https?:\/\//i.test(href ?? "");

const escapeAttr = (value) =>
  value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const richTextOptions = {
  renderNode: {
    hyperlink: (node, next) => {
      const href = safeHref(node.data?.uri);
      if (!href) return next(node.content);
      const target = isExternalHref(href) ? ' target="_blank" rel="noopener noreferrer"' : "";
      return `<a href="${escapeAttr(href)}"${target}>${next(node.content)}</a>`;
    },
  },
};

// Rich text -> HTML for dangerouslySetInnerHTML. The renderer escapes text; links go through safeHref.
export function richTextToSafeHtml(document) {
  return document ? documentToHtmlString(document, richTextOptions) : "";
}
